module.exports = __webpack_public_path__ + "img/background-path.6d3b9052.png";